"use strict";
// this and other enums whcih may be stored in database need to be coverted to maps as inserting new values will invalidate data
Object.defineProperty(exports, "__esModule", { value: true });
exports.Units = void 0;
var Units;
(function (Units) {
    Units[Units["Unknown"] = 0] = "Unknown";
    Units[Units["Degrees"] = 1] = "Degrees";
    Units[Units["Degrees_C"] = 2] = "Degrees_C";
    Units[Units["Percent"] = 3] = "Percent";
    Units[Units["hPA"] = 4] = "hPA";
    Units[Units["Volts"] = 5] = "Volts";
    Units[Units["mVolts"] = 6] = "mVolts";
    Units[Units["HMS"] = 7] = "HMS";
    Units[Units["Meters"] = 8] = "Meters";
    Units[Units["Millimeters"] = 9] = "Millimeters";
    Units[Units["Km"] = 10] = "Km";
    Units[Units["Rolls"] = 11] = "Rolls";
    Units[Units["Moves"] = 12] = "Moves";
    Units[Units["Count"] = 13] = "Count";
    Units[Units["RH"] = 14] = "RH";
    Units[Units["ALS"] = 15] = "ALS";
    Units[Units["Days"] = 16] = "Days";
    Units[Units["Hours"] = 17] = "Hours";
    Units[Units["Minutes"] = 18] = "Minutes";
    Units[Units["Seconds"] = 19] = "Seconds";
    Units[Units["Milliseconds"] = 20] = "Milliseconds";
    Units[Units["PPM"] = 21] = "PPM";
    Units[Units["Lux"] = 22] = "Lux";
})(Units || (exports.Units = Units = {}));
